import { Component, OnInit, Input } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Alert } from "./alert";

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css'],
  animations: [
    trigger('alertState', [
      state('hide', style({
        opacity: '0',
        display: 'none'
      })),
      state('show', style({
        opacity: '1',
        display: 'block'
      })),
      transition('hide => show, show => hide', animate('500ms ease-in'))
    ])
  ]
})
export class AlertComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  @Input() alert:Alert;

}



// WEBPACK FOOTER //
// ./src/app/alert/alert.component.ts